// import { useState } from "react";
// import { createReview } from "../../../../../../services/reviewService";

// export default function RatingForm({ itemId }) {
//   const [userName, setUserName] = useState("");
//   const [message, setMessage] = useState("");
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setError("");
//     setSuccess("");

//     if (!userName.trim() || !message.trim() || rating === 0) {
//       setError("All fields are required");
//       return;
//     }

//     setLoading(true);

//     try {
//       createReview({
//         name: userName, 
//         trip: itemId,
//         stars: rating,
//         message: message,
//         date: new Date().toLocaleDateString()
//       }).then((data) => {
//         setSuccess("Thanks for your review");
//         setUserName("");
//         setMessage("");
//         setRating(0);
//       })
//     } catch (err) {
//       setError("Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} style={styles.form}>
//       <h3 style={styles.title}>Leave a Review</h3>

//       <input
//         type="text"
//         placeholder="Your name"
//         value={userName}
//         onChange={(e) => setUserName(e.target.value)}
//         style={styles.input}
//       />

//       <textarea
//         placeholder="Your message"
//         value={message}
//         onChange={(e) => setMessage(e.target.value)}
//         rows={4}
//         style={styles.textarea}
//       />

//       <div style={styles.stars}>
//         {[1, 2, 3, 4, 5].map((value) => (
//           <span
//             key={value}
//             onClick={() => setRating(value)}
//             onMouseEnter={() => setHover(value)}
//             onMouseLeave={() => setHover(0)}
//             style={{
//               ...styles.star,
//               color: (hover || rating) >= value ? "#f59e0b" : "#d1d5db",
//             }}
//           >
//             ★
//           </span>
//         ))}
//       </div>

//       {error && <p style={styles.error}>{error}</p>}
//       {success && <p style={styles.success}>{success}</p>}

//       <button
//         type="submit"
//         disabled={loading}
//         style={{
//           ...styles.button,
//           opacity: loading ? 0.6 : 1,
//         }}
//       >
//         {loading ? "Submitting…" : "Submit Review"}
//       </button>
//     </form>
//   );
// }


// const styles = {
//   form: {
//     maxWidth: "400px",
//     padding: "20px",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     background: "#fff",
//   },
//   title: {
//     marginBottom: "12px",
//     fontSize: "18px",
//     fontWeight: "600",
//     color: "#111827",
//   },
//   input: {
//     width: "100%",
//     padding: "10px",
//     marginBottom: "10px",
//     borderRadius: "6px",
//     color: "black",
//     border: "1px solid #d1d5db",
//   },
//   textarea: {
//         color: "black",
//     width: "100%",
//     padding: "10px",
//     marginBottom: "12px",
//     borderRadius: "6px",
//     border: "1px solid #d1d5db",
//     resize: "vertical",
//   },
//   stars: {
//     display: "flex",
//     gap: "6px",
//     fontSize: "26px",
//     marginBottom: "12px",
//     cursor: "pointer",
//   },
//   star: {
//     transition: "color 0.15s ease",
//   },
//   button: {
//     width: "100%",
//     padding: "10px",
//     background: "#2563eb",
//     color: "#fff",
//     border: "none",
//     borderRadius: "6px",
//     fontWeight: "600",
//     cursor: "pointer",
//   },
//   error: {
//     color: "#dc2626",
//     marginBottom: "8px",
//     fontSize: "14px",
//   },
//   success: {
//     color: "#16a34a",
//     marginBottom: "8px",
//     fontSize: "14px",
//   },
// };

import { useState } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import { FiUser, FiMessageSquare, FiSend } from "react-icons/fi";
import { createReview } from "../../../../../../services/reviewService";
import "./review.scss";

export default function RatingForm({ itemId, tripName }) {
  const [formData, setFormData] = useState({
    userName: "",
    message: "",
    rating: 0,
  });
  const [hover, setHover] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!formData.userName.trim() || !formData.message.trim() || formData.rating === 0) {
      setError("Please fill in all fields and select a rating");
      return;
    }

    if (formData.message.length < 20) {
      setError("Please write a more detailed review (minimum 20 characters)");
      return;
    }

    setLoading(true);

    try {
      await createReview({
        name: formData.userName,
        trip: itemId,
        stars: formData.rating,
        message: formData.message,
        date: new Date().toLocaleDateString('en-US', { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        })
      });
      
      setSuccess("Thank you for your review! It has been submitted successfully.");
      setFormData({
        userName: "",
        message: "",
        rating: 0,
      });
    } catch (err) {
      setError("Failed to submit review. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="review-form-container">
      <div className="form-header">
        <h3>
          <FiMessageSquare /> Share Your Experience
        </h3>
        <p>Tell us about your adventure with {tripName}</p>
      </div>

      <form onSubmit={handleSubmit} className="review-form">
        <div className="form-group">
          <label htmlFor="userName">
            <FiUser /> Your Name
          </label>
          <input
            type="text"
            id="userName"
            name="userName"
            placeholder="Enter your name"
            value={formData.userName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Your Rating</label>
          <div className="star-rating">
            {[1, 2, 3, 4, 5].map((value) => (
              <button
                type="button"
                key={value}
                onClick={() => setFormData(prev => ({ ...prev, rating: value }))}
                onMouseEnter={() => setHover(value)}
                onMouseLeave={() => setHover(0)}
                className="star-btn"
              >
                {(hover || formData.rating) >= value ? (
                  <FaStar className="star filled" />
                ) : (
                  <FaRegStar className="star" />
                )}
              </button>
            ))}
            <span className="rating-text">
              {formData.rating > 0 ? `${formData.rating}.0 stars` : "Click to rate"}
            </span>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="message">Your Review</label>
          <textarea
            id="message"
            name="message"
            placeholder="Share details of your experience, what you liked, any suggestions..."
            value={formData.message}
            onChange={handleInputChange}
            rows={5}
            required
          />
          <div className="char-count">
            {formData.message.length} / 500 characters
          </div>
        </div>

        {error && <div className="alert error">{error}</div>}
        {success && <div className="alert success">{success}</div>}

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? (
            <>
              <span className="spinner"></span>
              Submitting...
            </>
          ) : (
            <>
              <FiSend /> Submit Review
            </>
          )}
        </button>
      </form>
    </div>
  );
}
